var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5297 10.8519H16.8554V13.5047C17.6226 11.979 19.59 10.6082 22.5453 10.6082C28.2109 10.6082 29.5559 13.6453 29.5559 19.2176V29.5377H23.8201V20.4866C23.8201 17.3133 23.0529 15.5237 21.0999 15.5237C18.3912 15.5237 17.2655 17.4524 17.2655 20.4852V29.5377H11.5297V10.8519ZM1.6943 29.2939H7.43009V10.6082H1.6943V29.2939ZM8.25174 4.51533C8.25196 4.9961 8.15661 5.47211 7.97125 5.91571C7.78588 6.3593 7.5142 6.76163 7.17198 7.0993C6.47853 7.78849 5.53988 8.17427 4.5622 8.1719C3.58624 8.17124 2.64976 7.78645 1.95528 7.10074C1.61431 6.76191 1.34354 6.35913 1.1585 5.91548C0.97346 5.47183 0.877784 4.99602 0.876953 4.51533C0.876953 3.54455 1.26412 2.61535 1.95672 1.92992C2.65058 1.24329 3.58746 0.858336 4.56363 0.858765C5.54158 0.858765 6.47938 1.2445 7.17198 1.92992C7.86314 2.61535 8.25174 3.54455 8.25174 4.51533Z",
    fill: "#FFFAE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.01b54182cd36ec09048460f9264beb8b.svg";
export { ForwardRef as ReactComponent };